import React, { useEffect, useMemo, useState } from "react";
import { useGetProformaInvoiceSearchDTO } from "../../../Reports/ReportList/Hook";
import CustomerCombo from "../../../Reports/ReportList/ReListByOrders/Components/CustomerCombo";
import { Grid } from "@mui/material";
import DesignerCombo from "../../../Reports/ReportList/ReListByOrders/Components/DesignerCombo";
import ComboBox from "../../../Reports/ReportList/Components/ComboBox";
import YearsDrop from "../components/YearsDrop";
import PersianDatePicker from "../components/PersianDatePicker";

function Filter({
  setFieldValue,
  setDesignerFiled,
  customerFieldValue,
  designerFiled,
  year,
  setYear,
  chartFilter,
  month,
  setMonth,
}) {
  const { data } = useGetProformaInvoiceSearchDTO();
  const [inputValue, setInputValue] = useState("");
  const [inpDesigner, setInpDesigner] = useState("");

  const optionCustomer = useMemo(() => {
    return data?.customers?.map((item) => ({
      label: item.key,
      value: item.value,
    }));
  }, [data?.customers]);
  const optionDesigner = useMemo(() => {
    return data?.designers?.map((item) => ({
      label: item.key,
      value: item.value,
    }));
  }, [data?.designers]);

  return (
    <Grid
      container
      display={"flex"}
      justifyContent={"start"}
      sx={{ lg: { maxWidth: "80%" }, xs: { maxWidth: "100%" } }}
    >
      {/* <Grid lg={3} xs={12}>
          {chartFilter.enum === 0 && <Month month={month} setMonth={setMonth} />}
        </Grid> */}

      <Grid item lg={2} xs={12}>
        {chartFilter.enum === 0 && (
          <PersianDatePicker
            year={year}
            setYear={setYear}
            month={month}
            setMonth={setMonth}
          />
        )}

        {chartFilter.enum === 1 && <YearsDrop year={year} setYear={setYear} />}
      </Grid>
    </Grid>
  );
}

export default Filter;
